(function() {
    'use strict';
 
 a3_pilot_reports.factory('GenericValuesFactory', GenericValuesFactory);

    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name GenericValuesFactory
    * @description 
    *    Generic add, edit or remove for list of values
    * @ngInject
    */   
 function GenericValuesFactory(localStorageMD5Service) {
		 
		var service = {
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			objList : objList,
			getValuesFromStorage : getValuesFromStorage,
			setValuesToStorage : setValuesToStorage,
			clearValuesFromStorage : clearValuesFromStorage,
			getValuesFromStorageAsStrings : getValuesFromStorageAsStrings
		}
        
        /**
         * Extend given object 
         * @memberof GenericValuesFactory
         * @param {object} obj The object that will be extended
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} object
         */
		function fromObject(obj,callback) {
			if (obj == null) return null;
			var newObj = new callback();
			newObj.Code = obj;
			return newObj;
		}
     
        /**
         * Extend given object list
         * @memberof GenericValuesFactory
         * @param {array} objList The list of objects that will be extended
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} objList
         */
		function fromObjectList(objList,callback) {
			if (objList == null) return null;

			var arrayLength = objList.length;
			var newObjList = [];

			for (var i = 0; i < arrayLength; i++) {
				var newObj = new callback();
				newObj.Code = objList[i];
				newObjList.push(newObj);
			}

			return newObjList;
		}

        /**
         * Get all the object's Code from given list
         * @memberof GenericValuesFactory
         * @param {array} objectList An object list
         * @returns {array} objectList
         */
		function objList(objList) {
			if (objList == null) return [];

			var arrayLength = objList.length;
			var newObjList = [];

			for (var i = 0; i < arrayLength; i++) {
				newObjList.push(objList[i].Code);
			}

			return newObjList;
		}
     
        /**
         * Get all the objects
         * @memberof GenericValuesFactory
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {array} objectList
         */
		function getValuesFromStorage(callback,type) {
			var objects = localStorageMD5Service.get(type);
			return fromObjectList(objects,callback);
		}
     
        /**
         * Set all the objects
         * @memberof GenericValuesFactory
         * @param {array} objects A list of objects.
         * @param {string} type A string which identifies the local storage name
         */
		function setValuesToStorage(objects,type) {
			localStorageMD5Service.set(type, objects);
		}
     
        /**
         * Remove all the objects
         * @memberof GenericValuesFactory
         * @param {string} type A string which identifies the local storage name
         */
		function clearValuesFromStorage(type) {
			localStorageMD5Service.remove(type);
		}
     
        /**
         * Get all the objects codes from local storage
         * @memberof GenericValuesFactory
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {array} objectList
         */
		function getValuesFromStorageAsStrings(callback,type) {
			var result = [];
			var objs = getValuesFromStorage(callback,type);
			if (objs != null || objs != undefined) {
				for (var i = 0; i < objs.length; i++) {
					result.push(objs[i].Code);
				}
			}
			return result;
		}																

	return service;
	}


 
 })();   